/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Tab_VideoInputs */

const en_preset_manager_tab_video = /** @type {(inputs: Preset_Manager_Tab_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const fr_preset_manager_tab_video = /** @type {(inputs: Preset_Manager_Tab_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const de_preset_manager_tab_video = /** @type {(inputs: Preset_Manager_Tab_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const it_preset_manager_tab_video = /** @type {(inputs: Preset_Manager_Tab_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const ru_preset_manager_tab_video = /** @type {(inputs: Preset_Manager_Tab_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видео`)
};

const es_preset_manager_tab_video = /** @type {(inputs: Preset_Manager_Tab_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const zh_cn2_preset_manager_tab_video = /** @type {(inputs: Preset_Manager_Tab_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频`)
};

const ja_preset_manager_tab_video = /** @type {(inputs: Preset_Manager_Tab_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオ`)
};

const hi_preset_manager_tab_video = /** @type {(inputs: Preset_Manager_Tab_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो`)
};

const pt_pt2_preset_manager_tab_video = /** @type {(inputs: Preset_Manager_Tab_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo`)
};

/**
* | output |
* | --- |
* | "Video" |
*
* @param {Preset_Manager_Tab_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_tab_video = /** @type {((inputs?: Preset_Manager_Tab_VideoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Tab_VideoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_tab_video(inputs)
	if (locale === "de") return de_preset_manager_tab_video(inputs)
	if (locale === "it") return it_preset_manager_tab_video(inputs)
	if (locale === "ru") return ru_preset_manager_tab_video(inputs)
	if (locale === "es") return es_preset_manager_tab_video(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_tab_video(inputs)
	if (locale === "ja") return ja_preset_manager_tab_video(inputs)
	if (locale === "hi") return hi_preset_manager_tab_video(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_tab_video(inputs)
	return en_preset_manager_tab_video(inputs)
});